.container {
  container-type: inline-size;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-16);
  padding: var(--zumpo-space-12) var(--zumpo-space-16);
  border: 1px solid var(--zumpo-line);
  border-radius: var(--zumpo-radius-24);
  background: var(--zumpo-paper);
}

/* The swatches' tap areas reach 8 px past them, into padding of their own
   that sits in the toolbar's; so nothing hangs out of its box. */
.colours {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-8);
  margin: calc(-1 * var(--zumpo-space-8));
  padding: var(--zumpo-space-8);
}

.swatch {
  position: relative;
  flex: none;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px var(--zumpo-line);
  cursor: pointer;
  touch-action: manipulation;
}

/* A swatch keeps Figma's size, but a tap lands anywhere in the 44 px around
   it, the size a thumb needs; on a phone the swatches sit 8 px apart, so the
   area grows only up and down there. */
.swatch::before {
  content: '';
  position: absolute;
  inset: calc(-1 * var(--zumpo-space-8));
}

/* The chosen colour: a 2 px paper ring inside a 2 px ink ring. */
.swatch[data-checked] {
  box-shadow:
    inset 0 0 0 2px var(--zumpo-paper),
    0 0 0 2px var(--zumpo-ink);
}

.swatch:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: 4px;
}

.divider {
  flex: none;
  width: 1px;
  height: 32px;
  background: var(--zumpo-line);
}

.tools {
  display: contents;
}

.sizes {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-4);
}

.size {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: var(--zumpo-radius-8);
  background: transparent;
  cursor: pointer;
}

@media (hover: hover) {
  .size:hover {
    background: var(--zumpo-cream);
  }
}

.size[data-checked] {
  background: var(--zumpo-sand);
  box-shadow: inset 0 0 0 2px var(--zumpo-ink);
}

.size:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.dot {
  width: var(--dot);
  height: var(--dot);
  border-radius: 50%;
  background: var(--zumpo-ink);
}

.spacer {
  flex: 1;
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-8);
}

/* Narrower than the Desktop stage (898 px), where the one line was drawn to
   fit: the colours on one line, the sizes and actions on a second. */
@container (max-width: 897px) {
  .toolbar {
    flex-wrap: wrap;
  }

  .divider {
    display: none;
  }

  .tools {
    display: flex;
    flex: 1 0 100%;
    align-items: center;
    gap: var(--zumpo-space-16);
  }
}

/* Phone: the colours across the top, sizes and icon-only actions under them. */
@container (max-width: 560px) {
  .toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: var(--zumpo-space-12);
    padding: var(--zumpo-space-12);
    border-radius: var(--zumpo-radius-16);
  }

  .colours {
    justify-content: space-between;
    gap: 0;
    margin: calc(-1 * var(--zumpo-space-12)) calc(-1 * var(--zumpo-space-4));
    padding: var(--zumpo-space-12) var(--zumpo-space-4);
  }

  .swatch {
    width: 22px;
    height: 22px;
  }

  .swatch::before {
    inset: calc(-1 * var(--zumpo-space-12)) calc(-1 * var(--zumpo-space-4));
  }

  .divider,
  .spacer {
    display: none;
  }

  .tools {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--zumpo-space-8);
  }

  .size {
    width: 36px;
    height: 36px;
  }

  .dot {
    max-width: 24px;
    max-height: 24px;
  }
}

/* A 320 px phone, 286 px being what the sizes and actions take: smaller
   swatches and sizes, closer together. */
@container (max-width: 285px) {
  .swatch {
    width: 20px;
    height: 20px;
  }

  .tools {
    gap: var(--zumpo-space-4);
  }

  .size {
    width: 32px;
    height: 32px;
  }

  .dot {
    max-width: 20px;
    max-height: 20px;
  }
}
